import type { EntityBatchSyncStatus } from './entityMutationSync'
import { deriveSyncOutcome, type SyncOutcome } from './syncOutcome'

// Thin per-surface wrapper. Logic lives in `deriveSyncOutcome` so every
// surface stays in lockstep (v2.1 finding #24 consolidation).
export type DatatableSyncOutcome = SyncOutcome

export const deriveDatatableSyncOutcome = (params: {
  status: EntityBatchSyncStatus
  skippedNotFoundCount: number
}): DatatableSyncOutcome => deriveSyncOutcome({ ...params, surfaceKey: 'datatable' })
